import { dateToQuarter } from 'src/utils/dateToQuarter';
import { CongestionProps } from '..';
import { isResolvedCongestion } from './isResolvedCongestion';
import { setEndNewEndDate } from './setEndNewEndDate';
import { quarterlyEndDateToString } from './quarterlyEndDateToString';

// Get The latest end date of the unsolved congestions and returns the year and the quarter this month belongs in.
export const getLatestEndDate = (
  congestionData: CongestionProps[]
): {
  latestEndDate: string;
  latestEndDateConsume: string;
  latestEndDateSupply: string;
} => {
  let latestEndDate: string | undefined;
  let latestEndDateConsume: string | undefined;
  let latestEndDateSupply: string | undefined;

  congestionData?.forEach((item) => {
    const consume = isResolvedCongestion(item.level.consume);
    const supply = isResolvedCongestion(item.level.supply);
    const solved = consume && supply;

    // Only checks the unsolved congestions
    if (!solved) {
      latestEndDate = setEndNewEndDate(item.latestEndDate, latestEndDate);
      latestEndDateConsume = setEndNewEndDate(item.latestEndDateConsume, latestEndDateConsume);
      latestEndDateSupply = setEndNewEndDate(item.latestEndDateSupply, latestEndDateSupply);
    }
  });

  const quarterlyEndDate = dateToQuarter(latestEndDate);
  const quarterlyEndDatConsume = dateToQuarter(latestEndDateConsume);
  const quarterlyEndDateSupply = dateToQuarter(latestEndDateSupply);

  return {
    latestEndDate: quarterlyEndDateToString(quarterlyEndDate),
    latestEndDateConsume: quarterlyEndDateToString(quarterlyEndDatConsume),
    latestEndDateSupply: quarterlyEndDateToString(quarterlyEndDateSupply),
  };
};

